import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditTrafficSource } from '../api/editTrafficSource';
import { Fields } from '../hooks/useTrafficSourceForm';

import { TrafficSourceForm } from './TrafficSourceForm';

type EditModalProps = {
  trafficSourceId: string;
  initialValues: Fields;
};

export const EditModal = NiceModal.create(({ initialValues, trafficSourceId }: EditModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditTrafficSource({
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Редактирование источника трафика"
    >
      <TrafficSourceForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params, _id: trafficSourceId })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
